<template>
  <div>
    <Header title="Configuration" />

    <Alert class="mb-4">
      <template #title>Configurer le système de primes</template>
      <p class="text-sm">
        Afin de motiver vos équipes à proposer les services d'assurance, vous avez la possibilité de leur rétribuer une
        partie de votre rémunération. Une fois les primes configurées, vous pouvez suivre le montant à reverser mois par
        depuis l'onglet
        <strong>Suivi des primes.</strong>
      </p>
    </Alert>

    <template v-if="store">
      <div class="mb-5">
        <div class="border-b border-gray-200 mb-4">
          <nav class="-mb-px flex space-x-8" aria-label="Tabs">
            <a
              v-for="tab in tabs"
              :key="tab.id"
              :href="generateTabLink(tab.id)"
              @click.prevent="selectTab(tab.id)"
              :class="[
                tab.active
                  ? 'border-primary text-primary-dark'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium cursor-pointer',
              ]"
            >
              {{ tab.name }}
            </a>
          </nav>
        </div>

        <component :is="currentTab.component" />
      </div>

      <div>
        <div class="flex justify-between items-center mb-5">
          <h3 class="text-2xl font-bold">Grille de primes</h3>
          <SecondaryButton @click="() => downloadRetributionConfigurationsPdf(store.id)">Exporter</SecondaryButton>
        </div>
        <RetributionTable :retributions="retributionConfigurations" :hide-manager-retribution="false" />
      </div>
    </template>
  </div>
</template>

<script>
import { Alert, SecondaryButton } from "@estaly/ui";
import RetributionTable from "@/components/retribution/RetributionTable.vue";
import Header from "@/components/admin/retributions/Header.vue";
import SellerRetributionConfiguration from "@/components/admin/retributions/SellerRetributionConfiguration.vue";
import ManagerRetributionConfiguration from "@/components/admin/retributions/ManagerRetributionConfiguration.vue";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    Header,
    Alert,
    SecondaryButton,
    RetributionTable,
    SellerRetributionConfiguration,
    ManagerRetributionConfiguration,
  },

  data() {
    return {
      selectedTabId: "seller-retribution",
    };
  },

  computed: {
    ...mapState("store", ["stores"]),
    ...mapState("retributionConfigurations", ["selectedStoreId", "retributionConfigurations"]),
    ...mapGetters("auth", ["isOrganizationOrStoreAdmin"]),

    filteredStores() {
      return this.stores.filter((store) => store.source === "offline" && store.status === "active");
    },

    store() {
      return this.stores.find((store) => store.id == this.selectedStoreId);
    },

    currentTab() {
      return this.tabs.find((tab) => tab.id === this.selectedTabId);
    },

    tabs() {
      const baseTabs = [
        {
          id: "seller-retribution",
          name: "Primes vendeurs",
          active: this.selectedTabId === "seller-retribution",
          component: SellerRetributionConfiguration,
        },
      ];

      if (this.isOrganizationOrStoreAdmin) {
        baseTabs.push({
          id: "manager-retribution",
          name: "Primes managers",
          active: this.selectedTabId === "manager-retribution",
          component: ManagerRetributionConfiguration,
        });
      }

      return baseTabs;
    },
  },

  beforeMount() {
    this.syncTabWithUrl();
  },

  watch: {
    $route: "syncTabWithUrl",
  },

  methods: {
    ...mapActions("retributionConfigurations", ["downloadRetributionConfigurationsPdf"]),

    selectTab(selectedTabId, replaceUrl = true) {
      this.selectedTabId = selectedTabId;
      this.tabs.forEach((tab) => {
        tab.active = tab.id === selectedTabId;
      });

      if (replaceUrl) {
        this.$router.push({ query: { tab: selectedTabId } });
      } else {
        this.$router.replace({ query: { tab: selectedTabId } });
      }
    },

    syncTabWithUrl() {
      const tabId = this.$route.query.tab || "seller-retribution";
      if (tabId !== this.currentTab.id) {
        this.selectTab(tabId, false);
      }
    },

    generateTabLink(tabId) {
      return this.$router.resolve({ query: { tab: tabId } }).href;
    },
  },
};
</script>
